function scrollPaneOf(target: HTMLElement) {
  let parent = target.parentElement;
  while (parent && parent !== target.ownerDocument.body) {
    if (
      parent.matches('[data-scroll-pane], [data-studio-scroll]') ||
      /^(auto|scroll)$/.test(getComputedStyle(parent).overflowY)
    ) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return null;
}

/** A new section starts at the top of its reader, including the document heading. */
export function scrollPaneToTop(target: HTMLElement) {
  const pane =
    scrollPaneOf(target) ??
    target.ownerDocument.scrollingElement ??
    target.ownerDocument.documentElement;
  if (typeof pane.scrollTo === 'function') pane.scrollTo({ top: 0, behavior: 'smooth' });
  else pane.scrollTop = 0;
}

/** Scroll the reader's own pane; never scroll clipped application-shell ancestors. */
export function scrollWithinPane(
  target: HTMLElement,
  options: { block?: 'start' | 'nearest'; behavior?: ScrollBehavior } = {},
) {
  const pane = scrollPaneOf(target);
  if (!pane || pane === document.documentElement) return;
  const rect = target.getBoundingClientRect();
  const viewport = pane.getBoundingClientRect();
  let delta = rect.top - viewport.top;
  if (options.block === 'nearest') {
    if (rect.top >= viewport.top && rect.bottom <= viewport.bottom) return;
    if (rect.top >= viewport.top) delta = rect.bottom - viewport.bottom;
  }
  const top = Math.max(0, pane.scrollTop + delta);
  if (typeof pane.scrollTo === 'function')
    pane.scrollTo({ top, behavior: options.behavior ?? 'instant' });
  else pane.scrollTop = top;
}
